export const GM_ERROR_CODES = {
    // Token aktywacyjny już wykorzystany.
    GMU_EMAIL_ALREADY_CONFIRMED: 12112,
};
